const designer = {
  title: ({ brandName }) => `Shop ${brandName} at italist | Best price in the market`,
  description: ({ brandName }) =>
    `Shop at italist: the largest selection of ${brandName} from Italy’s finest stores. EXPRESS international shipping!`
};

export default designer;
